import { QuestionMarkRounded } from "@mui/icons-material";
import { styled, Typography } from "@mui/material";
import { useLocation } from "react-router";

const NotFound = () => {
  const location = useLocation();
  let text = "Sorry content is not found...";
  if (location?.state?.message) {
    text = location.state.message;
  }
  return (
    <>
      <Title>
        <Typography variant="h6">Why..</Typography>
        <QuestionMarkRounded fontSize="large" />
      </Title>

      <Typography variant="h1" textAlign="center">
        404!
      </Typography>
      <Typography variant="h2" textAlign="center">
        {text}
      </Typography>
    </>
  );
};

const Title = styled("div")`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  margin-bottom: 20px;
`;

export default NotFound;
